import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {NavLink} from 'react-router-dom';
import {v4 as uuid} from 'uuid';
import classNames from 'classnames';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function MenuItem(props) {
  const {
    classes,
    isActive,
    isBottom,
    item,
    onClick,
  } = props;
  return (
    <ListItem
      key={uuid()}
      className={classes.navLinks__item}
      onClick={onClick}
    >
      <NavLink
        to={item.path}
        className={classNames(
          classes.navLinks__item_link,
          {
            [classes.navLinks__item_activeLink]: isActive,
            [classes.navLinks__item_linkBottom]: isBottom,
          },
        )}
      >
        <item.icon
          className={classNames(
            classes.navLinks__item_icon,
            {
              [classes.navLinks__item_bottomIcon]: isBottom,
              [classes.navLinks__item_bottomIconActive]: isBottom && isActive,
            },
          )}
        />
        <ListItemText
          primary={I18n.t(`navMenu.${item.name}`)}
          disableTypography={true}
          className={classNames(
            classes.navLinks__item_text,
            {
              [classes.navLinks__topItem_text]: !isBottom,
            },
          )}
        />
      </NavLink>
    </ListItem>
  );
}

MenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  isBottom: PropTypes.bool,
  onClick: PropTypes.func,
};

MenuItem.defaultProps = {
  isBottom: false,
  onClick: () => {},
};

export default MenuItem;
